import { Globe, UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

import { settingsBcLink } from '../model';

export const subNav: RouteListItem[] = [
  { path: '/settings/registrars/$id', name: 'Registrar', icon: UserCircle, show: true },
  { path: '/settings/registrars/$id/domains', name: 'Domains', icon: Globe, show: true },
];

export const breadcrumbsLinks: RouteListItem[] = [settingsBcLink, { path: '/settings/registrars', name: 'Registrars' }];
